@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.utils

import androidx.compose.runtime.Composable
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient
import org.example.project.service.ZustandManager


@Serializable
data class AufgabeZeile(
    val id: String = "",
    val label: String = "",
    val soll: Int? = null,
    val ist: Int = 0,
    val erledigt: Boolean = false,
    val erledigtAm: String = ""
)

@Serializable
data class AufgabeAenderung(
    val zeileId: String = "",
    val feld: String = "",
    val alt: String = "",
    val neu: String = "",
    val zeitpunkt: String = ""
)

@OptIn(ExperimentalSerializationApi::class)
@Serializable
data class All(

    @SerialName("geändertAm")  val geaendertAm: String = "",
    @SerialName("geändertUm")  val geaendertUm: String = "",
    val gewinn: String = "",
    val gueltigBis: String = "",
    val gueltigVon: String = "",
    @SerialName("geändertVon")  val geaendertVon: String = "",
    val abteilung: String = "",
    val abgabeArt: String = "",
    val abgaben: String = "",
    val auszahlung: String = "",
    val betrieblicheAbgaben: String = "",
    val persoenlicheAbgaben: String = "",
    val unternehmenVerfuegbar: String = "",
    val einkommensteuerMonatlich: String = "",
    val gewerbesteuerMonatlich: String = "",
    val gewerbesteuerHebesatz: String = "",
    val krankenkasseMonatlich: String = "",
    val krankenkasseProzent: String = "",
    val pflegeversicherungMonatlich: String = "",
    val pflegeversicherungProzent: String = "",
    val kirchensteuerProzent: String = "",
    val rentenversicherungMonatlich: String = "",
    val sonstigeAbgabenMonatlich: String = "",
    val addrPath: String = "",
    val adresse: String = "",
    val abfragePrio: Int = 0,
    val aktiv: Boolean = true,
    val aktivWa: Boolean = false,
    val aktivWe: Boolean = false,
    val aktivVon: String = "",
    val aktivBis: String = "",
    val aktion: String = "",
    val akquiseTyp: String = "",
    val akquiseAnspracheText: String = "",
    val akquiseFrageOeffnenText: String = "",
    val akquiseSystemProzessText: String = "",
    val akquiseSysteme: List<String> = emptyList(),
    val akquiseProzessFragen: List<String> = emptyList(),
    val akquiseDefinitionTyp: String = "",
    val akquiseDefinitionTypPrio: Int = 0,
    val akquiseDefinitionText: String = "",
    val akquiseDefinitionAntwortLabel1: String = "",
    val akquiseDefinitionAntwortLabel2: String = "",
    val akquiseDefinitionAntwortLabel3: String = "",
    val akquiseDefinitionAntworten: List<String> = emptyList(),
    val akquiseDefinitionReaktion1: String = "",
    val akquiseDefinitionReaktion2: String = "",
    val akquiseDefinitionReaktion3: String = "",
    val akquiseDefinitionReaktionen: List<String> = emptyList(),
    val akquiseDefinitionScriptId: String = "",
    val akquiseDefinitionAntwortIds: List<String> = emptyList(),
    val akquiseDefinitionAntwortTypen: List<String> = emptyList(),
    val akquiseDefinitionReaktionIds: List<String> = emptyList(),
    val scriptTyp: String = "",
    val scriptInhalt: String = "",
    val akquiseDefinitionId: String = "",
    val akquiseDefinitionBereich: String = "",
    val akquiseDefinitionPrio: Int = 0,
    val akquiseDefinitionAktiv: Boolean = true,
    val akquiseDefinitionBezeichnung: String = "",
    val akquiseDetails: List<All> = emptyList(),
    val akquiseDetailDefinitionId: String = "",
    val akquiseDetailBezeichnung: String = "",
    val akquiseDetailAusgewaehlt: Boolean = false,
    val akquiseDetailText: String = "",
    val akquiseNotizen: String = "",
    val akquiseDiagnose: String = "",
    val akquiseNaechsterMove: String = "",
    val akquiseStatus: String = "",
    val akquiseAbschlussAm: String = "",
    val akquiseCallAm: String = "",
    val akquiseFollowUpAm: String = "",
    val akquiseTerminId: String = "",
    val akquiseTerminAm: String = "",
    val akquiseCallTerminId: String = "",
    val akquiseProspectId: String = "",
    val kalenderErinnerungAm: String = "",
    val kalenderErinnerungWiederholungen: Int = 0,
    val kalenderErinnerungBestaetigt: Boolean = false,
    val akquiseAbschlussNotiz: String = "",
    val akquiseReminderEmailAm: String = "",
    val akquiseLadeGrund: String = "",
    val akquiseFaelligAm: String = "",
    val akquiseZugewiesenAnId: String = "",
    val akquiseZugewiesenAn: String = "",
    val akquiseZugewiesenAm: String = "",
    val akquiseErgebnis: String = "",
    val akquiseAktiverSchritt: String = "",
    val akquiseCallLog: List<All> = emptyList(),
    val leadInfos: List<All> = emptyList(),
    val leadInfoText: String = "",
    val leadInfoId: String = "",
    val akquiseLogTyp: String = "",
    val akquiseLogWert: String = "",
    val akquiseLogAm: String = "",
    val akquiseCallsAbgeschlossen: String = "",
    val akquisePositivAbgeschlossen: String = "",
    val akquiseNegativAbgeschlossen: String = "",
    val firmenKontaktiert: String = "",
    val emailVersendet: String = "",
    val emailWarteschlange: String = "",
    val emailBeantwortet: String = "",
    val emailAntwortquote: String = "",
    val emailVersandProWoche: String = "",
    val emailVersandFehler: String = "",
    val emailGeplantAm: String = "",
    val emailGeplantUm: String = "",
    val emailGesendetAm: String = "",
    val emailGesendetUm: String = "",
    val emailFlyerId: String = "",
    val emailFlyerGeoeffnet: Boolean = false,
    val emailFlyerEvents: List<All> = emptyList(),
    val emailVorlageId: String? = null,
    val anhangProfilId: String? = null,
    val emailStandard: Boolean = false,
    val emailAntwortTyp: String = "",
    val emailHtml: String = "",
    val emailVorlagen: List<All> = emptyList(),
    val emailInlineBilder: List<All> = emptyList(),
    val emailContentId: String = "",
    val emailSignaturHtml: String = "",
    val emailSignaturBilder: List<All> = emptyList(),
    val emailSignaturQuelle: String = "",
    val emailOutlookEntwuerfe: List<All> = emptyList(),
    val emailBetreffId: String = "",
    val emailAnspracheId: String = "",
    val emailTextId: String = "",
    val emailAntwortId: String = "",
    val emailDatensatzArt: String = "",
    val emailDatensaetze: List<All> = emptyList(),
    val emailProfilId: String = "",
    val emailAntwortProfilId: String = "",
    val emailProfilArt: String = "Nachricht",
    val emailBetreff: String = "",
    val emailText: String = "",
    val emailAnhangIds: List<String> = emptyList(),
    val emailDateiname: String = "",
    val emailContentType: String = "",
    val emailDateigroesse: Int = 0,
    val emailDateiBase64: String = "",
    val emailAbsender: String = "",
    val emailEmpfaenger: String = "",
    val emailLeadId: String = "",
    val emailConversationId: String = "",
    val emailInternetMessageId: String = "",
    val emailInReplyTo: String = "",
    val emailAntwortAufId: String = "",
    val emailAntwortProfilAutomatisch: Boolean = false,
    val emailReplyTo: String = "",
    val emailRichtung: String = "",
    val emailGraphConfigured: Boolean = false,
    val emailSyncAm: String = "",
    val emailProfile: List<All> = emptyList(),
    val emailAnhaenge: List<All> = emptyList(),
    val emailEntwuerfe: List<All> = emptyList(),
    val emailNachrichten: List<All> = emptyList(),
    val emailFirmen: List<All> = emptyList(),
    val anrede: String = "",
    val anschrift: String = "",
    val ansprechpartner: String = "",
    val ansprechpartnerPosition: String = "",
    val ansprechpartnerAufgabe: String = "",
    val anbieterFirma: String = "",
    val anbieterFirmenId: String = "",
    val anbieterName: String = "",
    val anbieterUserId: String = "",
    val anzahlTeilnehmer: String = "",
    val anzahlTore: String = "",
    val anzahlHallen: String = "",
    val anzahlRegalplaetze: String = "",
    val vertriebZusatzfelder: Map<String, String> = emptyMap(),
    val vertriebCheckpoint: String = "",
    val vertriebBereich: String = "",
    val vertriebZustand: String = "",
    val vertriebCheckpointAm: String = "",
    val vertriebCheckpointVon: String = "",
    val vertriebCheckpointAktion: String = "",
    val vertriebCheckpointVerlauf: List<All> = emptyList(),
    val vertriebMeilensteine: Map<String, String> = emptyMap(),
    val vertriebLetzteAktionAm: String = "",
    val vertriebWiedervorlageAm: String = "",
    val vertriebFollowUpAm: String = "",
    val vertriebFollowUpFaellig: Boolean = false,
    val vertriebCheckpointFristen: Map<String, Int> = emptyMap(),
    val vertriebCheckpointLabels: Map<String, String> = emptyMap(),
    val vertriebAbschlussErgebnis: String = "",
    val vertriebAbschlussGrund: String = "",
    val icp: String = "",
    val linkedinAngeschrieben: Boolean = false,
    val linkedinBenutzerId: String = "",
    val linkedinKontaktId: String = "",
    val linkedinAccessToken: String = "",
    val linkedinVerbunden: Boolean = false,
    val linkedinNetzwerkstatus: String = "",
    val linkedinSnapshotGeloescht: Boolean = false,
    val linkedinKontakteSyncAm: String = "",
    val linkedinChatSyncAm: String = "",
    val linkedinSyncPauseBis: String = "",
    val linkedinSyncLaeuft: Boolean = false,
    val linkedinSnapshotKontakteAnzahl: Int = 0,
    val linkedinArchivNachrichtenAnzahl: Int = 0,
    val linkedinDatensaetzeAnzahl: Int = 0,
    val linkedinSyncNeueLeads: Int = 0,
    val linkedinSyncWarnung: String = "",
    val linkedinAusgeblendet: Boolean = false,
    val linkedinDmGesendetAm: String = "",
    val linkedinLetzteNachrichtAm: String = "",
    val linkedinDmTyp: String = "",
    val linkedinDmLeadTypId: String = "",
    val linkedinDmInhalt: String = "",
    val linkedinDmCheckboxId: String = "",
    val linkedinDmCheckboxText: String = "",
    val linkedinDmCheckboxAktiv: Boolean = true,
    val linkedinDmCheckboxPrio: Int = 0,
    val linkedinDmCheckboxWerte: Map<String, Boolean> = emptyMap(),
    val linkedinDmEintraege: List<All> = emptyList(),
    val linkedinMaterialAngefragt: Boolean = false,
    val linkedinMaterialGesendet: Boolean = false,
    val linkedinFollowUpTage: Int = 4,
    val callFollowUpTage: Int = 4,
    val linkedinAntwortErhalten: Boolean = false,
    val linkedinGeschlossen: Boolean = false,
    val linkedinKontaktUnbearbeitet: Boolean = false,
    val linkedinLeadOffen: Boolean = false,
    val linkedinLeadAktiv: Boolean = false,
    val linkedinMaterialOffen: Boolean = false,
    val linkedinTerminGebucht: Boolean = false,
    val linkedinTerminwunsch: Boolean = false,
    val linkedinTerminSetzen: Boolean = false,
    val linkedinAbschlussAm: String = "",
    val linkedinAbschlussErgebnis: String = "",
    val linkedinAbschlussNotiz: String = "",
    val linkedinLetzteAntwortAm: String = "",
    val linkedinFollowUpAm: String = "",
    val linkedinFollowUpFaellig: Boolean = false,
    val linkedinProspectId: String = "",
    val leadTyp: String = "",
    val leadTypId: String = "",
    val vertriebCallName: String = "",
    val vertriebScriptBereich: String = "CALL",
    val vertriebCallFlow: List<All> = emptyList(),
    val vertriebCallCheckboxen: List<All> = emptyList(),
    val leadQuelle: String = "",
    val linkedin: String = "",
    val linkedinVernetztAm: String = "",
    val linkedinHatNachrichten: Boolean = false,
    val linkedinHatGesendeteNachrichten: Boolean = false,
    val linkedinKontakte: List<All> = emptyList(),
    val linkedinNachrichten: List<All> = emptyList(),
    val linkedinNachrichtAutor: String = "",
    val linkedinNachrichtEigen: Boolean = false,
    val linkedinUnterhaltungId: String = "",
    val linkedinNachrichtBetreff: String = "",
    val linkedinNachrichtAnhaenge: String = "",
    val artikelbezeichnung: String = "",
    val artikelNummer: String = "",
    val arbeitszeitmodell: String = "",
    val archivierung: String = "",
    val abgeschlossenAm: String = "",
    val abgeschlossenUm: String = "",
    val abschlussMonatLabel: String = "",
    val abschlussMonat: String = "",
    val abschlusstag: String = "",
    val abwesenheitsart: String = "",
    val arbeitsstunden: Double = 0.0,
    val arbeitszeitIst: Double = 0.0,
    val arbeitszeitMonatlich: Double = 0.0,
    val arbeitszeitSoll: Double = 0.0,
    val arbeitszeitTaeglich: Double = 0.0,
    val art: String = "",
    val betriebsart: String = "",
    val betriebsergebnis: String = "",
    val aufliegerkennzeichen: String = "",
    val aufliegerOk: Boolean = false,
    val auftraggeber: String = "",
    val auftragsdokumentationen: String = "",
    val auftragsart: String = "",
    val ausgaengeGesamt: String = "",
    val ausgabenBrutto: String = "",
    val ausgabenMwst: String = "",
    val ausgabenNetto: String = "",
    val ausgang: String = "",
    val absolviert: Boolean = false,
    val backupkosten: String = "",
    val bearbeitetAm: String = "",
    val bearbeitetUm: String = "",
    val bearbeitetVon: String = "",
    val bedeutung: String = "",
    val betrag: String = "",
    val beratungKosten: String = "",
    val lieferscheinnummer: String = "",
    val live: Boolean = true,
    val belegId: String = "",
    val belegdatum: String = "",
    val belegnummer: String = "",
    val belegAnzahl: Int = 0,
    val belegt: Boolean = false,
    val belegtTyp: String = "",
    val bemerkung: String = "",
    val bereich: String = "",
    val beschreibung: String? = null,
    val bezeichnung: String = "",
    val bonus: String = "",
    val brutto: String = "",
    val briefBetreff: String = "",
    val briefEmpfaengerZeilen: List<String> = emptyList(),
    val briefFooterZeilen: List<String> = emptyList(),
    val briefGrussformel: String = "",
    val briefText: String = "",
    val briefUnterschriftOrtDatum: String = "",
    val behinderungsstatus: String = "",
    val beginnAltersteilzeit: String = "",
    val betrieblicheAltersvorsorge: String = "",
    val bic: String = "",
    val bookingHtml: Boolean = false,
    val bewegungenGesamt: String = "",
    val calendarProvider: String = "",
    val cells: String = "",
    val categoryIcons: Map<String, String> = emptyMap(),
    val chatId: String = "",
    val cloudKosten: String = "",
    val columns: List<String> = emptyList(),
    val columnSettings: List<All> = emptyList(),
    val count: Int = 0,
    val createdAt: String = "",
    val crId: String = "",
    val crAenderungAktivModul: String = "",
    val crAnforderung: String = "",
    val crAngebotPdf: String = "",
    val crInhalt: String = "",
    val crKommentarIntern: String = "",
    val crAufwandFinal: Int = 0,
    val crAufwandStunden: Int = 0,
    val crBeschreibung: String = "",
    val crDokument: List<All> = emptyList(),
    val crNeuesModul: Boolean = false,
    val crNummer: String = "",
    val crPreis: Int = 0,
    val crPreisFinal: Int = 0,
    val crKosten: String = "",
    val crSatz: String = "",
    val crStatusLog: String = "",

    val crTickets: String = "",
    val crVerlinkungPdf: String = "",
    val crZusagePdf: String = "",
    val datenschutzAkzeptiert: Boolean = false,
    val datum: String = "",
    val datumVon: String = "",
    val datumBis: String = "",
    val day: Int = 0,
    val deleted: String = "",
    val deletedFor: String = "",
    val dev: Boolean = true,
    val driverAvatarFile: String = "",
    val driverAvatarOpenUrl: String = "",
    val driverAvatarPosX: Double = 0.0,
    val driverAvatarPosY: Double = 0.0,
    val driverAvatarZoom: String = "",
    val dauerProbezeit: String = "",
    val dokumentDataUrl: String = "",
    val dokumentHash: String = "",
    val dokumentName: String = "",
    val dokumentRelativPfad: String = "",
    val ebene: String = "",
    val ebeneBis: String = "",
    val ebeneVon: String = "",
    val einmalzahlung: String = "",
    val eintrittsdatum: String = "",
    val email: String = "",
    val emailPrivat: String = "",
    val eingaengeGesamt: String = "",
    val einnahmenBrutto: String = "",
    val einnahmenMwst: String = "",
    val einnahmenNetto: String = "",
    val eingang: String = "",
    val eingeladenVonFirma: String = "",
    val eingeladenVonName: String = "",
    val eingeladenVonUserId: String = "",
    val einladungsKey: String = "",
    val eingeladenVon: String = "",
    val endeAltersteilzeit: String = "",
    val empfaenger: String = "",
    val error: String = "",
    val erstelltAm: String = "",
    val erstelltUm: String = "",
    val erstelltVon: String = "",
    val erstantwort: String = "",
    val erstkontakt: String = "",
    val event: String = "",
    val erstellerFirma: String = "",
    val erstellerFirmenId: String = "",
    val erstellerName: String = "",
    val erstellerUserId: String = "",
    val faelligkeit: String = "",

    val extraMeeting: String = "",
    val extraSchulungRemote: String = "",
    val fach: String = "",
    val fachBis: String = "",
    val fachVon: String = "",
    val fahrername: String = "",
    val farbe: String? = "",
    val fax: String = "",
    val feedArt: String = "",
    val feedEvent: String = "",
    val feedEventLabel: String = "",
    val feedLsNummer: String = "",
    val feedUhrzeit: String = "",
    val fahrzeughersteller: String = "",
    val file: String = "",
    val footerMode: String = "",
    val familienstand: String = "",
    val firmaImNetzwerk: Boolean = false,
    val finanzamt: String = "",
    val firmenfahrzeug: String = "",
    val firma: String = "",
    val lagerart: String = "",
    val produktion: Boolean = false,
    val qualitaetsmanagement: String = "",
    val qmZertifizierungen: String = "",
    val umschlaglager: Boolean = false,
    val warenart: String = "",
    val firmenId: String = "",
    val firmenstammPfad: String = "",
    val frei: String = "",
    val freitext: String = "",
    val geburtsdatum: String = "",
    val geburtsort: String = "",
    val gebuchtAm: String = "",
    val buchungsart: String = "",
    val buchungsdatum: String = "",
    val buchungstyp: String = "",
    val buchungsuhrzeit: String = "",
    val gebuchtUm: String = "",
    val gebuchtVon: String = "",
    val gegruendetAm: String = "",
    val gesamtbetragEuro: String = "",
    val grund: String = "",
    val gehaltBruttoMonat: String = "",
    val haendler: String = "",

    val geschaeftsfuehrer: String = "",
    val geschlecht: String = "",
    val gesperrt: Boolean? = false,
    val globalerChat: Boolean = false,
    val halbBelegt: Boolean = false,
    val halle: String = "",
    val halleBis: String = "",
    val hallenbezeichnung: String = "",
    val halleVon: String = "",
    val headerMode: String = "",
    val hauptbeschaeftigung: String = "",
    val hoechsterSchulabschluss: String = "",
    val mobil: String = "",
    val mobilPrivat: String = "",
    val mobilIstPaletten: Int = 0,
    val mobilWePalettenBruch: Int = 0,
    val mobilWePalettenFehlmenge: Int = 0,
    val mobilWePalettenUnbeschaedigt: Int = 0,
    val mobilWePalettenUeberzaehlig: Int = 0,
    val mobilPalettenAusgang: String = "",
    val mobilPalettenAbgeladenBestaetigt: Boolean = false,
    val mobilPalettenGetauscht: Boolean = false,
    val webKontrolleAbgeschlossen: Boolean = false,
    val webKontrolleAbgeschlossenAm: String = "",
    val webKontrolleAbgeschlossenUm: String = "",
    val webKontrolleFehlerfrei: Boolean = false,
    val mhd: String = "",
    val monitorKey: String = "",
    val hausnummer: String = "",
    val hidden: Set<String> = emptySet(),
    val hiddenFromLauncher: Boolean = false,
    val hideDriverNav: Boolean = false,
    val iban: String = "",
    val id: String = "",
    val ids: List<String> = emptyList(),
    val imageValues: Map<String, String> = emptyMap(),
    val importHash: String = "",
    val importKonfidenz: String = "",
    val importStatus: String = "",
    val infracode: String = "",
    val insolvenzschutzNachweis: String = "",
    val infraAnzeigeCode: String = "",
    val infraErzeugterCode: String = "",
    val infraKlartext: String = "",
    val infraHallen: String = "",
    val infraTorFormat: String = "",
    val istCheckbox: Boolean = true,
    val istEingabe: Boolean = false,
    val istkunde: Boolean = false,
    val intervall: String = "",
    val istnetzwerk: Boolean = false,
    val jahr: Int = 0,
    val jahresurlaub: Double = 0.0,
    val kapazitaetCcg1: Int = 0,
    val kapazitaetCcg2: Int = 0,
    val karteiSeiten: Map<String, String> = emptyMap(),
    val kennzeichen: String = "",
    val kinderfreibetrag: String = "",
    val kiAuswahl: String = "",
    val kirchensteuerpflichtig: String = "",
    val kontakt: String = "",
    val kontoinhaber: String = "",
    val kontrollBezeichnung: String = "",
    val kontrollId: String = "",
    val kontrollPflicht: Boolean = true,
    val kontrolliert: Boolean = false,
    val kontrolliertWE: Boolean = false,
    val kontrollOptions: List<String> = emptyList(),
    val kontrollPositionen: List<All> = emptyList(),
    val kontrollTyp: String = "checkbox",
    val kontostand: String = "",
    val kostenpflichtig: Boolean = false,
    val kostenstelle: String = "",
    val kreditinstitut: String = "",
    val krankenkasse: String = "",
    val kuerzel: String = "",
    val kunde: String = "",
    val kundenId: String = "",
    val kundeFirma: String = "",
    val kundeFirmenId: String = "",
    val kundeName: String = "",
    val kundeUserId: String = "",
    val koffer: Boolean = false,
    val kuehlung: Boolean = false,
    val kurzbezeichnung: String = "",
    val land: String = "DE",
    val lastMessage: String = "",
    val letzteAntwortAm: String = "",
    val leerpalettenanzahl: Int = 0,
    val lfdNr: Int = 0,
    val lieferant: String = "",
    val lieferscheine: String = "",
    val lizenz: String = "",
    val lizenzen: List<All> = emptyList(),
    val lizenzkey: String = "",
    val lcode: String = "",
    val logoSrc: String = "",
    val lokalerTeilnehmer: String = "",

    val lizenzMonatlich: String = "",
    val lsId: String = "",
    val lkwkennzeichen: String = "",
    val loesungsweg: String = "",
    val manuelleFehlerursache: String = "",
    val manuelleLoesung: String = "",
    val meetings: String = "",
    val meetingKosten: String = "",
    val menge: String = "",
    val mengenart: String = "",
    val microsoftCalendarUserId: String = "",
    val microsoftEventId: String = "",
    val microsoftICalUId: String = "",
    val microsoftLastModifiedDateTime: String = "",
    val microsoftSensitivity: String = "",
    val microsoftShowAs: String = "",
    val microsoftWebLink: String = "",
    val messageIcon1: String = "",
    val messageIcon2: String = "",
    val messageIcon3: String = "",
    val messageText1: String = "",
    val messageText2: String = "",
    val messageText3: String = "",
    val month: Int = 0,
    val monat: String = "",
    val moeglicheTage: Int = 0,
    val modulBeschreibung: String = "",
    val module: List<All> = emptyList(),
    val modulAktiv: Boolean = false,

    val modulErstelltAm: String = "",
    val moduleGalleryAssetIds: List<Int> = emptyList(),
    val modulId: Int = 0,
    val modulInstalliert: Boolean = false,
    val modulKategorie: String = "",
    val modulName: String = "",
    val modulReferenz: String = "",
    val modulScreens: Map<String, Boolean> = emptyMap(),
    val modulTyp: String = "",
    val mwst: String = "",
    val mwstSatz: String = "",
    val nachname: String = "",
    val nve: String = "",
    val nationalitaet: String = "",
    val nationalitaet2: String = "",
    val name: String = "",
    val nextMonthIso: String = "",
    val netto: String = "",
    val netzwerkProfil: Boolean = false,
    val netzwerkZugang: Boolean = false,
    val kontakteAktiv: Boolean = true,
    val profilIntern: Boolean = true,
    val profilOnline: Boolean = true,
    val nodeEingerichtet: Boolean = false,
    val nodePort: String = "",
    val notiz: String = "",
    val notizen: String = "",
    val nummerZweitversicherer: String = "",
    val onboarding: String = "",
    val onboardingPreis: String = "",
    val openUrl: String = "",
    val originalId: String = "",
    val originalLfdNr: String = "",
    val originalName: String = "",
    val originalStandortKey: String = "",
    val originalZustand: String = "",
    val ort: String = "",
    val ortTyp: String = "",
    val pdf: String = "",
    val ownerFirmenId: String = "",
    val planer: Boolean = false,
    val palettenanzahl: Int = 0,
    val palettenart: String = "",
    val palettentyp: String = "",
    val palIst: String = "",
    val palKontoDifferenz: String = "",
    val palSoll: String = "",
    val palettenschein: String = "",
    val palettentauschAktiv: Boolean = true,
    val palettentauschWeAktiv: Boolean = true,
    val palettentauschWaAktiv: Boolean = true,
    val parkplaetzeImYardBenutzen: Boolean = true,
    val palettenWerte: Map<String, String> = emptyMap(),
    val pin: String = "",
    val yardPin: String = "",
    val pinBestaetigt: Boolean = false,
    val passwortVerifiziert: Boolean = false,
    val participants: String = "",
    val readBy: String = "",
    val ok: Boolean = false,
    val partnerJournalId: String = "",
    val partnerSourceFirmenId: String = "",
    val personalnummer: String = "",
    val privatnummer: String = "",
    val platz: String = "",
    val platzcode: String = "",
    val parkplatzVon: String = "",
    val parkplatzBis: String = "",
    val person: All? = null,
    val plz: String = "",
    val position: String = "",
    val pos: String = "",
    val positionAnzahl: Int = 0,
    val previousMonthIso: String = "",
    val preise: List<All> = emptyList(),
    val profileFehlt: Boolean = false,
    val providerId: String = "",
    val prio: String = "",
    val problembeschreibung: String = "",
    val qrCodeText: String = "",
    val qrCode: String = "",
    val qrLabel: String = "",
    val qmDokumentation: String = "",
    val quelle: String = "",
    val downloadUrl: String = "",
    val regal: String = "",
    val regalBis: String = "",
    val regalVon: String = "",
    val rechnungsnummer: String = "",
    val rechnungsdatum: String = "",
    val rechnungAnzahl: Int = 0,
    val rolle: String = "",
    val reserviertDelta: Double = 0.0,
    val reservierteUeberstunden: Double = 0.0,
    val resturlaub: Double = 0.0,
    val schulungFlow: Boolean = false,
    val schulungHinweis: Boolean = false,
    val schulungId: String = "",
    val schulungsModus: String = "",
    val schulungKosten: String = "",
    val startSchulung: String = "",
    val endeSchulung: String = "",
    val teilgenommen: Boolean = false,
    val screenBerechtigungen: Map<String, String> = emptyMap(),
    val screenCategory: String = "",
    val screenKey: String = "",
    val buildDatensatzTyp: String = "",
    val buildAktion: String = "",
    val buildVersion: String = "",
    val buildVorversion: String = "",
    val buildUmgebung: String = "",
    val buildNodeIds: List<String> = emptyList(),
    val buildZustand: Int = 0,
    val buildLiveFreigegeben: Boolean = false,
    val buildVerifiziert: Boolean = false,
    val buildAktiv: Boolean = false,
    val buildEreignisTyp: String = "",
    val buildWert: String = "",
    val buildKommentar: String = "",
    val buildNodeId: String = "",
    val buildNodeFirma: String = "",
    val buildNodeStatus: String = "",
    val buildNodeVersion: String = "",
    val buildNodePort: String = "",
    val buildWorkerAnzahl: Int = 0,
    val buildBenutzerAnzahl: Int = 0,
    val liveFreigegeben: Boolean = false,
    val setupkosten: String = "",
    val serviceTermin: Boolean = false,
    val serviceType: String = "",
    val settingsWerte: Map<String, String> = emptyMap(),
    val shopInstalledVersion: String = "",
    val shopPurchased: Boolean = false,
    val shopPurchasedDate: String = "",
    val shopStoreVersion: String = "",
    val scope: String = "",
    val signatur: String = "",
    val signaturOrtDatum: String = "",
    val snapAnnehmen: Boolean = false,
    val snapStatus: String = "",
    val snapKey: String = "",
    val snapChatId: String = "",
    val snapKontaktlisteTeilen: Boolean = false,
    val snapZeitfensterBuchen: Boolean = true,
    val snapHofFreigabe: Boolean = false,
    val snapAuftraegeTeilen: Boolean = false,
    val snapNetzwerkfunktionen: Boolean = false,
    val sonstiges: String = "",
    val saldo: String = "",
    val slots: String = "",
    val sortKey: String = "",
    val syncError: String = "",
    val syncStatus: String = "",
    val source: String = "",
    val sourceFirmenId: String = "",
    val sourceKey: String = "",
    val sourceMandantId: String = "",
    val sourceUserId: String = "",
    val endToEndFlow: Boolean = false,
    val flowWeAvis: Boolean = false,
    val flowTyp: String = "",
    val flowStatus: String = "",
    val flowId: String = "",
    val flowSourceFirmenId: String = "",
    val flowSourceCompleted: Boolean = false,
    val flowSourceWaTour: String = "",
    val flowSourceWaLkwId: String = "",
    val flowTargetFirmenId: String = "",
    val flowTargetWeId: String = "",
    val flowTargetWeLieferscheinnummer: String = "",
    val slotStandortId: String = "",
    val standortId: String = "",
    val slotIndex: String = "",
    val slotDriverUserId: String = "",
    val slotYardStandortKey: String = "",
    val slotIntervallMinuten: Int = 30,
    val slotAnzahl: Int = 6,
    val slotAnzahlWe: Int = 3,
    val slotAnzahlWa: Int = 3,
    val slotDeaktivierteFenster: String = "",
    val slotBuchungVorlaufStunden: Int = 0,
    val slotBuchungVorlaufTage: Int = 365,
    val slotBereich: String = "",
    val slotDatum: String = "",
    val slotAbholort: String = "",
    val slotLadenTouren: String = "",
    val slotLiefernBelege: String = "",
    val slotKundenFirma: String = "",
    val slotGebuchtVon: String = "",
    val lieferantFirmenId: String = "",
    val empfaengerFirmenId: String = "",
    val auftraggeberFirmenId: String = "",
    val unternehmerFirmenId: String = "",
    val slotLhmTyp: String = "",
    val slotLhmTypId: String = "",
    val lhmTypId: String = "",
    val anbieterVorname: String = "",
    val anbieterNachname: String = "",
    val clearHeaderSelection: Boolean = false,
    val clearSelectedCell: Boolean = false,
    val clearContextMenu: Boolean = false,
    val zweiFaktorToken: String = "",
    val zweiFaktorErforderlich: Boolean = false,
    val zweiFaktorEinrichtung: Boolean = false,
    val zweiFaktorQrCode: String = "",
    val zweiFaktorFehler: Boolean = false,
    val zweiFaktorGesperrt: Boolean = false,
    val zweiFaktorVerbleibendeVersuche: String = "",
    val passwort: String = "",
    val passwortFehler: String = "",
    val emailFehler: String = "",
    val loading: Boolean = false,
    val registrationMode: String = "",
    val snapKeyConnected: Boolean = false,
    val snapKeyError: String = "",
    val snapKeyLoading: Boolean = false,
    val driverTorAssignedPopupConfirmed: Boolean = false,
    val driverOpenCount: String = "",
    val driverClosedCount: String = "",
    val driverTotalCount: String = "",
    val mobileBearbeiterUserId: String = "",
    val mobileBearbeiterName: String = "",
    val mobileBearbeiterKuerzel: String = "",
    val mobileBearbeitungGestartetUm: String = "",
    val infraStandorte: String = "",
    val torSystemgesetztUm: String = "",
    val fahrerDokumenteBestaetigungOffen: Boolean = false,
    val dokumenteFertig: Boolean = false,
    val fahrerBestaetigt: Boolean = false,
    val externalJournalId: String = "",
    val aufgenommenAm: String = "",
    val mobilLeergutKontrolle: String = "",
    val mobilPendingLeergut: String = "",
    val driverLeergutDabei: Boolean = false,
    val driverVorgeladen: Boolean = false,
    val driverVorgeladenPaletten: Int = 0,
    val yardabschlussOffenPaletten: Int = 0,
    val parkplatzId: Int = 0,
    val onboardingPreisEinheit: String = "",
    val lizensierungPreisEinheit: String = "",
    val crStd: String = "",
    val crPreisProStd: String = "",
    val supportTickets: String = "",
    val meetingStd: String = "",
    val meetingPreisProStd: String = "",
    val schulungStd: String = "",
    val schulungPreisProStd: String = "",
    val beratungStd: String = "",
    val beratungPreisProStd: String = "",
    val sozialversicherungsnummer: String = "",
    val sprache: String = "",
    val sperrgrund: String? = "",
    val standort: String = "",
    val startbildschirm: String = "",
    val abteilungen: List<All> = emptyList(),
    val standortLabels: List<Map<String, String>> = emptyList(),
    val standortOutlines: List<List<String>> = emptyList(),
    val standortParkplaetze: List<Map<String, Int>> = emptyList(),
    val standortTiles: Map<String, String> = emptyMap(),
    val standortTore: List<Map<String, Int>> = emptyList(),
    val standortZoom: Double = 1.0,
    val status: String = "",
    val stempelungen: List<All> = emptyList(),
    val sessions: List<All> = emptyList(),
    val webseitenWiederkehrer: List<All> = emptyList(),
    val webseitenBesuche: List<All> = emptyList(),
    val webseitenSeiten: List<All> = emptyList(),
    val webseitenFlyer: List<All> = emptyList(),
    val webseitenIp: String = "",
    val webseitenBesuchId: String = "",
    val webseitenDatum: String = "",
    val webseitenUhrzeit: String = "",
    val webseitenEinstieg: String = "",
    val webseitenSitzungsdauer: String = "",
    val webseitenGesamtdauer: String = "",
    val webseitenSeitenadresse: String = "",
    val webseitenWiederholteBesuche: Int = 0,
    val webseitenFlyerDownloads: Int = 0,
    val webseitenSeiteUrl: String = "",
    val webseitenSeiteDatum: String = "",
    val webseitenSeiteUhrzeit: String = "",
    val webseitenSeiteVerweildauer: String = "",
    val webseitenFlyerName: String = "",
    val webseitenFlyerId: String = "",
    val webseitenFlyerDatum: String = "",
    val webseitenFlyerUhrzeit: String = "",
    val zeitprofilId: String = "",
    val zeitraum: String = "",
    val zeitprofilName: String = "",
    val vonSekunden: Int = 0,
    val bisSekunden: Int = 0,
    val dauerSekunden: Int = 0,
    val bruttozeitSekunden: Int = 0,
    val pauseSekunden: Int = 0,
    val arbeitszeitSekunden: Int = 0,
    val pausen: List<All> = emptyList(),
    val sollstunden: Double = 0.0,
    val stunden: Double = 0.0,
    val stundenBedarf: Double = 0.0,
    val stundenDelta: Double = 0.0,
    val stundenkonto: Double = 0.0,
    val zeitkontoAbgerechnet: Boolean = false,
    val zeitkontoBuchung: String = "",
    val zeitkontoStunden: Double = 0.0,
    val zeitkontoArbeitszeitStunden: Double = 0.0,
    val zeitkontoFreigegebenStunden: Double = 0.0,
    val steuerklasse: String = "",
    val steuerId: String = "",
    val steuernummer: String = "",
    val strasse: String = "",
    val stufe: Int = 0,
    val supportart: String = "",
    val supportPreis: String = "",
    val supportKosten: String = "",
    val supportTicket: String = "",
    val telefon: String = "",
    val telefonPrivat: String = "",
    val tauschpartner: String = "",
    val tauschpartnerAdresse: String = "",
    val tauschpartnerOrt: String = "",
    val tauschpartnerOriginal: String = "",
    val tauschart: String = "",
    val targetFirmenId: String = "",
    val targetUserIds: String = "",
    val tag: All? = null,
    val tage: List<String> = emptyList(),
    val tagesstunden: Double = 0.0,
    val teilnehmer: String = "",
    val teilnehmerAnzeige: String = "",
    val teilnehmerAuswahl: String = "",
    val teilnehmerUserIds: String = "",
    val kalendertage: List<String> = emptyList(),
    val urlaubstag: Boolean? = null,
    val anzahlTage: Int = 0,
    val terminkalenderIntern: Boolean = true,
    val terminkalenderOnline: Boolean = true,
    val terminalId: String = "",
    val terminalLabel: String = "",
    val ticketgrund: String = "",
    val ticketnummer: String = "",
    val titel: String? = null,
    val klaerung: String = "",
    val terminArt: String = "",
    val timestamp: String = "",
    val tor: Int? = null,
    val torcode: String? = null,
    val tore: List<Int> = emptyList(),
    val toreBis: String = "",
    val toreVon: String = "",
    val torZugewiesenUhrzeit: String = "",
    val typ: String = "",
    val aufgabeTyp: String = "",
    val aufgabeErledigt: Boolean = false,
    val aufgabeZeilen: List<AufgabeZeile> = emptyList(),
    val aufgabeLog: List<AufgabeAenderung> = emptyList(),
    val ueberstundenGenommen: Double = 0.0,
    val uhrzeit: String = "",
    val uhrzeitAbgeschlossen: String = "",
    val uhrzeitAnmeldung: String = "",
    val uhrzeitBis: String = "",
    val uhrzeitTorvergabe: String = "",
    val uhrzeitVon: String = "",
    val umsatzsteuerId: String = "",
    val unternehmer: String = "",
    val updatedAt: String = "",
    val updateAvailable: Boolean = false,
    val user: All? = null,
    val userId: String = "",
    val ustZahllast: String = "",
    val userKuerzel: String = "",
    val userName: String = "",
    val urlaub: Boolean = false,
    val urlaubGenommen: Double = 0.0,
    val urlaubId: String = "",
    val urlaubReserviert: Double = 0.0,
    val urlaubVerfuegbarExtra: Double = 0.0,
    val verbrauch: List<All> = emptyList(),
    val verbraucht: Int = 0,
    val verladedatum: String = "",
    val verladeuhrzeit: String = "",
    val lizensierungPreis: String = "",
    val vertragstyp: String = "",
    val vertragsende: String = "",
    val versichertennummer: String = "",
    val visibleLimit: Int = 2000,
    val vorgesetzter: String = "",
    val vorgangsart: String = "",
    val vorgangstyp: String = "",
    val vorname: String = "",
    val urlaubstageProJahr: String = "",
    val resturlaubVorjahr: String = "",
    val resturlaubVerfaelltAm: String = "",
    val resturlaubVerfallen: Boolean = false,
    val resturlaubVerfallenTage: Double = 0.0,
    val resturlaubVerbraucht: Double = 0.0,
    val jahresurlaubVerbraucht: Double = 0.0,
    val resturlaubVerfuegbar: Double = 0.0,
    val jahresurlaubVerfuegbar: Double = 0.0,
    val gesamtanspruch: Double = 0.0,
    val verfuegbar: Double = 0.0,
    val verfuegbarDelta: Double = 0.0,
    val krankheitstage: Int = 0,
    val vpCCG1: String = "",
    val vpCCG2: String = "",
    val webseite: String = "",
    val webLink: String = "",
    val wert: String = "",
    val wochenstunden: String = "",
    val leitstandAuskunftWaStandortId: String = "",
    val waStandortId: String = "",
    val weSammelId: String = "",
    val waSammelId: String = "",
    val waSammelPin: String = "",
    val waStandortAnkunft: Boolean = false,
    val yardabschlussIstPaletten: Int = 0,
    val year: Int = 0,
    val zeitkonto: Double = 0.0,
    val zeitkontoVerfuegbar: Double = 0.0,
    val zeitreserve: Double = 0.0,
    val zeitreserveIst: Double = 0.0,
    val zweitversicherung: String = "",
    val zusatzTeilnehmer: String = "",
    val zuschuesse: String = "",
    val zugangDesktop: Boolean = true,
    val zugangMobil: Boolean = true,
    val zugangCompanion: Boolean = false,
    val zweiFaktorAktiv: Boolean = false,
    val zweiFaktorEingerichtet: Boolean = false,
    val zweiFaktorFehlversuche: Int = 0,
    val zustand: Int = ZustandManager.RESERVIERT,
    var ablaufPrio: Int = 0,
    var aktiviertAm: String? = null,
    var aktiviertUm: String? = null,
    var aktiviertVon: String? = null,
    var key: String = "",
    var label: String = "",
    var icon: String = "",
    var paletten: MutableMap<String, String> = mutableMapOf(),
    var problemGeloest: Boolean = false,


    @Transient
    var verwaltungsLabel: String = "",
    @Transient
    var screenMode: String = "content",
    @Transient
    var popupWidthPx: Int = 980,
    @Transient
    var popupMinWidthPx: Int = 720,
    @Transient
    var popupHeightPx: Int = 700,
    @Transient
    var popupMinHeightPx: Int = 520,
    @Transient
    var popupInitialXPx: Double = 170.0,
    @Transient
    var popupInitialYPx: Double = 90.0,
    @Transient
    var content: (@Composable (All) -> Unit)? = null,

    ) {
    companion object AllNames {
        val names: Map<String, String> = mapOf(
            "ansprechpartnerPosition" to "Position",
            "anzahlTore" to "Tore",
            "anzahlHallen" to "Hallen",
            "anzahlRegalplaetze" to "Regalplätze",
            "icp" to "ICP",
            "linkedinAngeschrieben" to "DM gesendet",
            "linkedinDmGesendetAm" to "DM gesendet am",
            "linkedinBenutzerId" to "LinkedIn-Benutzer-ID",
            "linkedinAccessToken" to "LinkedIn-Zugangstoken",
            "linkedinVerbunden" to "LinkedIn verbunden",
            "linkedinAusgeblendet" to "LinkedIn-Kontakt ausgeblendet",
            "linkedinLetzteNachrichtAm" to "Letzte gesendete LinkedIn-Nachricht am",
            "callFollowUpTage" to "Call-Follow-up-Frist in Tagen",
            "linkedinDmTyp" to "Verwendet in",
            "linkedinDmLeadTypId" to "Lead-Typ",
            "linkedinDmInhalt" to "Nachricht",
            "linkedinDmCheckboxId" to "DM-Checkbox-ID",
            "linkedinDmCheckboxText" to "DM-Checkbox",
            "linkedinDmCheckboxAktiv" to "DM-Checkbox aktiv",
            "linkedinDmCheckboxPrio" to "DM-Checkbox-Reihenfolge",
            "linkedinDmCheckboxWerte" to "DM-Qualifizierung",
            "linkedinDmEintraege" to "DM-Index",
            "linkedinMaterialAngefragt" to "Material angefordert",
            "linkedinMaterialGesendet" to "Material gesendet",
            "linkedinFollowUpTage" to "LinkedIn-Follow-up-Frist in Tagen",
            "linkedinAntwortErhalten" to "LinkedIn-Antwort erhalten",
            "linkedinGeschlossen" to "LinkedIn abgeschlossen",
            "linkedinKontaktUnbearbeitet" to "LinkedIn-Kontakt unbearbeitet",
            "linkedinLeadOffen" to "Offener LinkedIn-Lead",
            "linkedinLeadAktiv" to "Aktiver LinkedIn-Lead",
            "linkedinMaterialOffen" to "LinkedIn-Material offen",
            "linkedinTerminGebucht" to "LinkedIn-Termin gebucht",
            "linkedinTerminwunsch" to "Termin gewünscht",
            "linkedinTerminSetzen" to "Termin setzen",
            "linkedinAbschlussAm" to "LinkedIn-Abschluss am",
            "linkedinAbschlussErgebnis" to "LinkedIn-Abschluss",
            "linkedinAbschlussNotiz" to "LinkedIn-Abschlussnotiz",
            "linkedinLetzteAntwortAm" to "Letzte LinkedIn-Antwort",
            "linkedinFollowUpAm" to "LinkedIn-Follow-up am",
            "linkedinFollowUpFaellig" to "LinkedIn-Follow-up offen",
            "linkedinProspectId" to "LinkedIn-Prospect",
            "leadTyp" to "Lead Typ",
            "leadTypId" to "Lead-Typ-ID",
            "leadQuelle" to "Leadquelle",
            "linkedin" to "LinkedIn",
            "linkedinVernetztAm" to "Vernetzt am",
            "linkedinHatNachrichten" to "LinkedIn-Chat vorhanden",
            "linkedinHatGesendeteNachrichten" to "LinkedIn-Nachrichten gesendet",
            "linkedinKontakte" to "LinkedIn-Kontakte",
            "linkedinNachrichten" to "LinkedIn-Nachrichten",
            "linkedinNachrichtAutor" to "LinkedIn-Absender",
            "linkedinNachrichtEigen" to "Eigene LinkedIn-Nachricht",
            "linkedinUnterhaltungId" to "LinkedIn-Unterhaltung",
            "linkedinNachrichtBetreff" to "LinkedIn-Betreff",
            "linkedinNachrichtAnhaenge" to "LinkedIn-Anhänge",
            "status" to "Zustand",
            "emailGeplantAm" to "Versand geplant am",
            "emailGeplantUm" to "Geplant um",
            "emailGesendetAm" to "Gesendet am",
            "emailGesendetUm" to "Gesendet um",
            "emailFlyerGeoeffnet" to "Flyer geöffnet",
            "emailFlyerId" to "Flyer-ID",
            "webseitenIp" to "Besucher-IP",
            "letzteAntwortAm" to "Letzter Kontakt",
            "emailVorlageId" to "E-Mail Vorlage",
            "anhangProfilId" to "Flyerprofil",
            "akquiseTyp" to "Akquise Typ",
            "akquiseAnspracheText" to "Ansprache",
            "akquiseFrageOeffnenText" to "Frage öffnen",
            "akquiseSystemProzessText" to "System / Prozess",
            "akquiseSysteme" to "Systeme",
            "akquiseProzessFragen" to "Prozessfragen",
            "akquiseDefinitionTyp" to "Typ",
            "scriptTyp" to "Typ",
            "scriptInhalt" to "Inhalt",
            "akquiseDefinitionTypPrio" to "Typ-Prio",
            "akquiseDefinitionText" to "Text",
            "akquiseDefinitionAntwortLabel1" to "Antwort 1",
            "akquiseDefinitionAntwortLabel2" to "Antwort 2",
            "akquiseDefinitionAntwortLabel3" to "Antwort 3",
            "akquiseDefinitionReaktion1" to "Reaktion 1",
            "akquiseDefinitionReaktion2" to "Reaktion 2",
            "akquiseDefinitionReaktion3" to "Reaktion 3",
            "akquiseDefinitionId" to "Definitions-ID",
            "akquiseDefinitionBereich" to "Bereich",
            "akquiseDefinitionPrio" to "Text-Prio",
            "akquiseDefinitionAktiv" to "Aktiv",
            "akquiseDefinitionBezeichnung" to "Bezeichnung",
            "akquiseDetails" to "Akquise-Details",
            "akquiseDetailDefinitionId" to "Definitions-ID",
            "akquiseDetailAusgewaehlt" to "Ausgewählt",
            "akquiseDetailText" to "Zusatztext",
            "akquiseNotizen" to "Akquise-Notizen",
            "akquiseDiagnose" to "Diagnose",
            "akquiseNaechsterMove" to "Nächster Schritt",
            "akquiseStatus" to "Call-Zustand",
            "akquiseAbschlussAm" to "Call abgeschlossen am",
            "akquiseCallAm" to "Call-Termin am",
            "akquiseFollowUpAm" to "Follow-up fällig am",
            "akquiseTerminId" to "Call-Termin-ID",
            "akquiseCallTerminId" to "Call-Kalender-ID",
            "akquiseProspectId" to "Akquise-Prospect-ID",
            "kalenderErinnerungAm" to "Kalender-Erinnerung am",
            "kalenderErinnerungWiederholungen" to "Kalender-Erinnerung Wiederholungen",
            "kalenderErinnerungBestaetigt" to "Kalender-Erinnerung best\u00e4tigt",
            "akquiseAbschlussNotiz" to "Call-Abschlussnotiz",
            "akquiseReminderEmailAm" to "Reminder zur E-Mail vom",
            "akquiseLadeGrund" to "Call-Anlass",
            "akquiseFaelligAm" to "Call fällig am",
            "akquiseErgebnis" to "Call-Ergebnis",
            "akquiseAktiverSchritt" to "Aktiver Gesprächsschritt",
            "akquiseCallLog" to "Call-Log",
            "akquiseLogTyp" to "Log-Typ",
            "akquiseLogWert" to "Log-Wert",
            "akquiseLogAm" to "Log-Zeitpunkt",
            "emailProfilId" to "E-Mail-Profil",
            "emailAntwortProfilId" to "Standard-Antwortprofil",
            "emailProfilArt" to "E-Mail-Profilart",
            "emailBetreff" to "E-Mail-Betreff",
            "emailText" to "E-Mail-Text",
            "emailAnhangIds" to "E-Mail-Anhänge",
            "emailDateiname" to "Anhang-Dateiname",
            "emailContentType" to "Anhang-Dateityp",
            "emailDateigroesse" to "Anhang-Dateigröße",
            "emailDateiBase64" to "Anhang-Dateiinhalt",
            "emailAbsender" to "E-Mail-Absender",
            "emailEmpfaenger" to "E-Mail-Empfänger",
            "emailLeadId" to "E-Mail-Firmendatensatz",
            "emailConversationId" to "Outlook-Gespräch",
            "emailInternetMessageId" to "Internet-Nachrichten-ID",
            "emailInReplyTo" to "Referenz der beantworteten Nachricht",
            "emailAntwortAufId" to "Antwort auf Nachricht",
            "emailAntwortProfilAutomatisch" to "Antwortprofil automatisch wählen",
            "emailReplyTo" to "E-Mail-Antwortadresse",
            "emailRichtung" to "E-Mail-Richtung",
            "emailGraphConfigured" to "Outlook konfiguriert",
            "emailSyncAm" to "Letzter Outlook-Abgleich",
            "emailProfile" to "E-Mail-Profile",
            "emailAnhaenge" to "E-Mail-Anhangsbestand",
            "emailEntwuerfe" to "E-Mail-Entwürfe",
            "emailNachrichten" to "E-Mail-Nachrichten",
            "emailFirmen" to "E-Mail-Dashboard-Firmen",
            "inhaber" to "Inhaber",
            "geschaeftsfuehrer" to "Geschäftsführer",
            "gruendungsdatum" to "Gründungsdatum",
            "steuerId" to "Steuer-ID",
            "umsatzsteuerId" to "Umsatzsteuer-ID",
            "interneIdentnummer" to "Interne Identnummer",
            "firmenlogo" to "Firmenlogo",
            "firmenlogoZoom" to "Firmenlogo Zoom",
            "webseite" to "Webseite",
            "steuernummer" to "Steuernummer",
            "ustId" to "USt-IdNr",
            "snapSichtbarImNetzwerk" to "Sichtbar im Netzwerk",
            "snapNetzwerkfunktionen" to "Netzwerkfunktionen",
            "snapHofTeilen" to "Hof teilen",
            "snapDokumenteTeilen" to "Dokumente teilen",
            "snapMitFirmen" to "Snappen mit Firmen",
            "sprache" to "Sprache",
            "snapKey" to "SnapKey",
            "snapKontaktlisteTeilen" to "Kontaktliste teilen",
            "snapZeitfensterBuchen" to "Zeitfenster buchen",
            "snapHofFreigabe" to "Hof freigeben",
            "snapAuftraegeTeilen" to "Aufträge teilen",
            "netzwerkZugang" to "Netzwerk Zugang",
            "netzwerkProfil" to "Terminkalender",
            "globalerChat" to "Globaler Chat",
            "kontakteAktiv" to "Kontakte",
            "profilOnline" to "Profil Online",
            "profilIntern" to "Profil intern",
            "terminkalenderOnline" to "Terminkalender Online",
            "terminkalenderIntern" to "Terminkalender intern",
            "abomodell" to "Abo Modell",
            "adresse" to "Adresse",
            "aktiv" to "Aktiv",
            "aktiveModule" to "Aktive Module",
            "aktiveModuleL" to "Aktive Module L",
            "aktiveModuleM" to "Aktive Module M",
            "aktiveModuleS" to "Aktive Module S",
            "aktiveModuleXL" to "Aktive Module XL",
            "aktiveModuleXXL" to "Aktive Module XXL",
            "aktivierungModulL" to "Aktivierung Modul L",
            "aktivierungModulM" to "Aktivierung Modul M",
            "aktivierungModulS" to "Aktivierung Modul S",
            "aktivierungModulXL" to "Aktivierung Modul XL",
            "aktivierungModulXXL" to "Aktivierung Modul XXL",
            "aktivWa" to "Aktiv Warenausgang",
            "aktivWe" to "Aktiv Wareneingang",
            "aktiviertAm" to "Aktiviert am",
            "aktiviertUm" to "Aktiviert um",
            "aktiviertVon" to "Aktiviert von",
            "angelegtAm" to "Angelegt am",
            "anschrift" to "Anschrift",
            "ansprechpartner" to "Ansprechpartner",
            "abwesenheitsart" to "Abwesenheitsart",
            "anzeigeName" to "Anzeige Name",
            "archivierung" to "Archivierung",
            "archivKosten" to "Archiv Kosten",
            "art" to "Art",
            "artbezeichnung" to "Art Bezeichnung",
            "auftraggeber" to "Auftraggeber",
            "auftragsart" to "Auftragsart",
            "aufpreisModul" to "Aufpreis Modul",
            "aufliegerOk" to "Auflieger OK",
            "aufliegerkennzeichen" to "Auflieger Kennzeichen",
            "backupkosten" to "Backup Kosten",
            "backupSchutz" to "Backup Schutz",
            "bankinstitut" to "Bankinstitut",
            "bearbeitetAm" to "Bearbeitet am",
            "bearbeitetUm" to "Bearbeitet um",
            "bearbeitetVon" to "Bearbeitet von",
            "bedeutung" to "Bedeutung",
            "belegt" to "Belegt",
            "belegtTyp" to "Belegt Typ",
            "lieferscheinnummer" to "Lieferscheinnummer",
            "bemerkung" to "Bemerkung",
            "bereich" to "Bereich",
            "beschreibung" to "Beschreibung",
            "bezeichnung" to "Bezeichnung",
            "briefBetreff" to "Brief Betreff",
            "briefEmpfaengerZeilen" to "Brief Empfaengerzeilen",
            "briefFooterZeilen" to "Brief Footerzeilen",
            "briefGrussformel" to "Brief Grussformel",
            "briefText" to "Brieftext",
            "briefUnterschriftOrtDatum" to "Brief Ort/Datum",
            "cloudKosten" to "Cloud Kosten",
            "cloudServer" to "Cloud Server",
            "cloudService" to "Cloud Service",
            "columnSettings" to "Spalteneinstellungen",
            "columns" to "Spalten",
            "crAenderungAktivModul" to "CR Änderung Aktiv Modul",
            "crAnforderung" to "CR Anforderung",
            "crAngebotPdf" to "CR Angebot PDF",
            "crInhalt" to "CR Inhalt",
            "crKommentarIntern" to "CR Kommentar Intern",
            "crAufwandFinal" to "CR Aufwand Final",
            "crAufwandStunden" to "CR Aufwand Stunden",
            "crBeschreibung" to "CR Beschreibung",
            "crDokument" to "CR Dokument",
            "crFrei" to "CR Frei",
            "crGenutzt" to "CR Genutzt",
            "crGesamt" to "CR Gesamt",
            "crGratis" to "CR Gratis",
            "crJahr" to "CR Jahr",
            "crKontingentFrei" to "CR Kontingent Frei",
            "crKontingentFreiStunden" to "CR Kontingent Frei Stunden",
            "crMonat" to "CR Monat",
            "crNeuesModul" to "CR Neues Modul",
            "crNummer" to "CR Nummer",
            "crPreis" to "CR Preis",
            "crPreisStunde" to "CR Preis Stunde",
            "crSatz" to "CR Satz",
            "crSigniertAm" to "CR Signiert am",
            "crSigniertVon" to "CR Signiert von",
            "crStundensatz" to "CR Stundensatz",
            "crTickets" to "CR Tickets",
            "crStatusLog" to "CR Status Log",
            "crVerlinkungPdf" to "CR Verlinkung PDF",
            "crPreisFinal" to "CR Preis Final",
            "crZusagePdf" to "CR Zusage PDF",
            "crAdminSignatur" to "CR Admin Signatur",
            "crKundeSignatur" to "CR Kunden Signatur",
            "datenschutzAkzeptiert" to "Datenschutz Akzeptiert",
            "datum" to "Datum",
            "dynamischePalettenWerte" to "Dynamische Palettenwerte",
            "ebene" to "Ebene",
            "ebenenbezeichnung" to "Ebenenbezeichnung",
            "einmalzahlung" to "Einmalzahlung",
            "einmalzahlungWeiter" to "Einmalzahlung Weiter",
            "einmalzahlungWeiteres" to "Einmalzahlung Weiteres",
            "email" to "E-Mail",
            "empfaenger" to "Empfänger",
            "erstelltAm" to "Erstellt am",
            "erstelltUm" to "Erstellt um",
            "erstelltVon" to "Erstellt von",
            "fach" to "Fach",
            "fahrername" to "Fahrername",
            "fax" to "Fax",
            "finanzamt" to "Finanzamt",
            "farbe" to "Farbe",
            "fehlerart" to "Fehlerart",
            "istnetzwerk" to "Netzwerk",
            "istkunde" to "Kunde",
            "firmenId" to "Firmen-ID",
            "firmenstammPfad" to "Firmenstamm Pfad",
            "frei" to "Frei",
            "geaendertAm" to "Geändert am",
            "geaendertUm" to "Geändert um",
            "geaendertVon" to "Geändert von",
            "gebuchtAm" to "Gebucht am",
            "gebuchteModule" to "Gebuchte Module",
            "gesamtkostenJahr" to "Gesamtkosten Jahr",
            "gesamtkostenMonat" to "Gesamtkosten Monat",
            "gesperrt" to "Gesperrt",
            "halbBelegt" to "Halb Belegt",
            "halle" to "Halle",
            "hallenbezeichnung" to "Hallenbezeichnung",
            "mobil" to "Mobil",
            "hidden" to "Versteckte Spalten",
            "iban" to "IBAN",
            "id" to "ID",
            "istCheckbox" to "Ist Checkbox",
            "istEingabe" to "Ist Eingabe",
            "kapazitaetCcg1" to "Kapazität CCG1",
            "kapazitaetCcg2" to "Kapazität CCG2",
            "kappa" to "Kappa",
            "kdnr" to "FirmenId (Kurz)",
            "kennzeichen" to "Kennzeichen",
            "kiSupport" to "KI Support",
            "klasse" to "Klasse",
            "kommiPalettenCCG1" to "Kommission Paletten CCG1",
            "kommiPalettenCCG2" to "Kommission Paletten CCG2",
            "kontakt" to "Kontakt",
            "kontrolle" to "Kontrolle",
            "kontrolliert" to "Kontrolliert",
            "kontrolliertWE" to "Kontrolliert WE",
            "kontrollAktiv" to "Kontroll Aktiv",
            "kontrollBezeichnung" to "Kontroll Bezeichnung",
            "kontrollId" to "Kontroll ID",
            "kontrollPflicht" to "Kontroll Pflicht",
            "kontrollOptions" to "Kontroll Optionen",
            "kontrollPositionen" to "Kontrollpositionen",
            "kontrollTyp" to "Kontroll Typ",
            "kostenpflichtig" to "Kostenpflichtig",
            "kreditinstitut" to "Kreditinstitut",
            "kuerzel" to "Kürzel",
            "kunde" to "Kunde",
            "kundenbezeichnung" to "Kundenbezeichnung",
            "firmenId" to "Firmen-ID",
            "kurzbezeichnung" to "Kurzbezeichnung",
            "land" to "Land",
            "lsId" to "LS-ID",
            "laufzeitAktuell" to "Laufzeit Aktuell",
            "lfdNr" to "Lfd. Nr.",
            "lieferant" to "Lieferant",
            "lizenz" to "Lizenz",
            "lizenzL" to "Lizenz L",
            "lizenzM" to "Lizenz M",
            "lizenzMonatlich" to "Lizenzierung",
            "lizenzS" to "Lizenz S",
            "lizenzXL" to "Lizenz XL",
            "lizenzXXL" to "Lizenz XXL",
            "lizenzkey" to "Lizenzkey",
            "lkwkennzeichen" to "LKW Kennzeichen",
            "loesungsweg" to "Lösungsweg",
            "lPreis" to "Listenpreis L",
            "mPreis" to "Listenpreis M",
            "meetings" to "Meetings",
            "menge" to "Menge",
            "menuSlots" to "Menü Slots",
            "modulAktiv" to "Modul Aktiv",
            "modulAktivBis" to "Modul Aktiv bis",
            "modulAktivSeit" to "Modul Aktiv seit",
            "modulBeschreibung" to "Modul Beschreibung",
            "modulErstelltAm" to "Modul Erstellt am",
            "modulFreigegeben" to "Modul Freigegeben",
            "modulGeaendertAm" to "Modul Geändert am",
            "modulGroesse" to "Modul Größe",
            "modulId" to "Modul ID",
            "modulName" to "Modul Name",
            "modulReferenz" to "Modul Referenz",
            "modulScreens" to "Modul Screens",
            "modulTyp" to "Modul Typ",
            "modulZuordnungId" to "Modul Zuordnung ID",
            "modulbezeichnung" to "Modulbezeichnung",
            "module" to "Module",
            "name" to "Name",
            "vorname" to "Vorname",
            "nachname" to "Nachname",
            "nodePort" to "Node Port",
            "nodeEingerichtet" to "Node eingerichtet",
            "notiz" to "Notiz",
            "notizen" to "Notizen",
            "olaPaletten" to "OLA Paletten",
            "ort" to "Ort",
            "paket" to "Paket",
            "palOffen" to "Paletten Offen",
            "palVerladen" to "Paletten Verladen",
            "palettenanzahl" to "Palettenanzahl",
            "leerpalettenanzahl" to "Leerpalettenanzahl",
            "palettenkonto" to "Palettenkonto",
            "pin" to "PIN",
            "pinBestaetigt" to "PIN bestätigt",
            "passAktiv" to "Pass Aktiv",
            "passwortVerifiziert" to "Passwort Verifiziert",
            "platz" to "Platz",
            "platzcode" to "Platzcode",
            "plz" to "PLZ",
            "preisverwaltung" to "Preisverwaltung",
            "prio" to "Priorität",
            "problembeschreibung" to "Problembeschreibung",
            "rechnungsdatum" to "Rechnungsdatum",
            "rechnungsEmail" to "Rechnungs-E-Mail",
            "rechnungsnummer" to "Rechnungsnummer",
            "regal" to "Regal",
            "regalbezeichnung" to "Regalbezeichnung",
            "rolle" to "Rolle",
            "signatur" to "Signatur",
            "sPreis" to "Listenpreis S",
            "screen1" to "Screen 1",


            "screen2" to "Screen 2",
            "screen3" to "Screen 3",
            "screen4" to "Screen 4",
            "screen5" to "Screen 5",
            "screenBerechtigungen" to "Screen Berechtigungen",
            "screenKey" to "Screen Key",
            "startbildschirm" to "Startbildschirm",
            "setupkosten" to "Setup Kosten",
            "setupVorOrt" to "Setup Vor Ort",
            "softwareL" to "Software L",
            "softwareM" to "Software M",
            "softwareS" to "Software S",
            "softwareXL" to "Software XL",
            "softwareXXL" to "Software XXL",
            "sperrgrund" to "Sperrgrund",
            "sprachIndex" to "Sprachindex",
            "standort" to "Standort",
            "stufe" to "Stufe",
            "supportFrei" to "Support Frei",
            "supportGesamt" to "Support Gesamt",
            "supportGenutzt" to "Support Genutzt",
            "supportInkl" to "Support Inkludiert",
            "supportJahr" to "Support Jahr",
            "supportMonat" to "Support Monat",
            "supportPreis" to "Support Kosten",
            "supportTicket" to "Support Ticket",
            "sonstiges" to "Sonstiges",
            "slotStandortId" to "Slot Standort-ID",
            "supportTicketsFrei" to "Support Tickets Frei",
            "supportTicketsGenutzt" to "Support Tickets Genutzt",
            "supportTicketsUebrig" to "Support Tickets Übrig",
            "supportart" to "Supportart",
            "teamsExtra" to "Teams Extra",
            "telefon" to "Telefon",
            "temperatur" to "Temperatur",
            "themeMode" to "Themen Mode",
            "ticketFrei" to "Ticket Frei",
            "ticketPreis" to "Ticket Preis",
            "ticketgrund" to "Ticketgrund",
            "ticketnummer" to "Ticketnummer",
            "ticketsFrei" to "Tickets Frei",
            "ticketsGenutzt" to "Tickets Genutzt",
            "titel" to "Titel",
            "tor" to "Tor",
            "torBelegtZeitMillis" to "Tor Belegt Zeit (ms)",
            "torFreigegebenZeitMillis" to "Tor Freigegeben Zeit (ms)",
            "torZugewiesenUhrzeit" to "Tor Zugewiesen Uhrzeit",
            "torcode" to "Torcode",
            "typ" to "Typ",
            "typbezeichnung" to "Typbezeichnung",
            "uhrzeitAbgeschlossen" to "Uhrzeit Abgeschlossen",
            "uhrzeitAnmeldung" to "Uhrzeit Anmeldung",
            "uhrzeitTorvergabe" to "Uhrzeit Torvergabe",
            "unternehmer" to "Unternehmer",
            "updatePreis" to "Update Preis",
            "upgradeAm" to "Upgrade am",
            "upgradeAuf" to "Upgrade auf",
            "upgradeVon" to "Upgrade von",
            "upgradeVonUser" to "Upgrade von User",
            "userErstelltAm" to "User Erstellt am",
            "userErstelltUm" to "User Erstellt um",
            "userErstelltVon" to "User Erstellt von",
            "userGeaendertAm" to "User Geändert am",
            "userGeaendertUm" to "User Geändert um",
            "userGeaendertVon" to "User Geändert von",
            "personalnummer" to "Personalnummer",
            "companySlug" to "Firmen-Slug",
            "userName" to "User Name",
            "verladeDatum" to "Verlade Datum",
            "verladedatum" to "Verlade Datum (alt)",
            "verladedauer" to "Verlade Dauer",
            "verladeUhrzeit" to "Verlade Uhrzeit",
            "verladeuhrzeit" to "Verlade Uhrzeit (alt)",
            "verlaengertAm" to "Verlängert am",
            "zugangDesktop" to "Zugang Desktop",
            "zugangMobil" to "Zugang Mobil",
            "zugangCompanion" to "Zugang Companion",
            "visibleLimit" to "Sichtbarkeitslimit",
            "vollpalettenCcg1" to "Vollpaletten CCG1",
            "vollpalettenCcg2" to "Vollpaletten CCG2",
            "vordefiniert" to "Vordefiniert",
            "vpCCG1" to "VP CCG1",
            "vpCCG2" to "VP CCG2",
            "wareOk" to "Ware OK",
            "waStandortId" to "WA Standort-ID",
            "wartung" to "Wartung",
            "wartungM" to "Wartung M",
            "wartungMonatlich" to "Wartung Monatlich",
            "wartungS" to "Wartung S",
            "wartungXL" to "Wartung XL",
            "waSammelId" to "WA Sammel-ID",
            "waSammelPin" to "WA Sammel-PIN",
            "xlPreis" to "Listenpreis XL",
            "xxlPreis" to "Listenpreis XXL",
            "zustand" to "Zustand",
            "zustandWare" to "Zustand Ware",
            "lizenzen" to "Lizenzen",
            "module" to "Module",
            "preise" to "Preise",
            "verbrauch" to "Verbrauch",
            "vorname" to "Vorname",
            "nachname" to "Nachname",
            "abteilung" to "Abteilung",
            "position" to "Position",
            "vorgesetzter" to "Vorgesetzter",
            "eintrittsdatum" to "Eintrittsdatum",
            "geburtsdatum" to "Geburtsdatum",
            "vertragstyp" to "Vertragstyp",
            "arbeitszeitmodell" to "Arbeitszeitmodell",
            "gehaltBruttoMonat" to "Gehalt brutto / Monat",
            "bonus" to "Bonus",
            "steuerklasse" to "Steuerklasse",
            "sozialversicherungsnummer" to "Sozialversicherungsnr.",
            "strasse" to "Straße",
            "hausnummer" to "Hausnummer",
            "personalnummer" to "Personalnummer",
            "firma" to "Firma",
            "gegruendetAm" to "gegründet",
            "onboarding" to "Onboarding",
            "extraSchulungRemote" to "Schulung",
            "extraMeeting" to "Meeting",
            "urlaubstageProJahr" to "Urlaubstage pro Jahr",
            "resturlaubVorjahr" to "Resturlaub aus Vorjahr",
            "resturlaubVerfaelltAm" to "Resturlaub verfällt am",
            "resturlaubVerfallenTage" to "Verfallener Resturlaub",
            "resturlaubVerbraucht" to "Verbrauchter Resturlaub",
            "jahresurlaubVerbraucht" to "Verbrauchter Jahresurlaub",
            "resturlaubVerfuegbar" to "Verfügbarer Resturlaub",
            "jahresurlaubVerfuegbar" to "Verfügbarer Jahresurlaub",
            "gesamtanspruch" to "Gesamtanspruch",
            "verfuegbar" to "Verfügbar",
            "krankheitstage" to "Krankheitstage",
            "stundenkonto" to "Stundenkonto",
            "stundenDelta" to "Stundenänderung",
            "urlaubId" to "Urlaubs-ID"




            )
    }
}
